import { render, staticRenderFns } from "./customer-study.vue?vue&type=template&id=3431517c&scoped=true"
import script from "./customer-study.vue?vue&type=script&lang=js"
export * from "./customer-study.vue?vue&type=script&lang=js"
import style0 from "./customer-study.vue?vue&type=style&index=0&id=3431517c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3431517c",
  null
  
)

export default component.exports